"use client";

import { ASSETS_BASE_PREFIX } from "@/lib/constants";
import { TCommunityInfo } from "@/types/community";
import CommunitySearch from "./community-search";
import CommunityStats from "./stats";

const PublicFeedHero = ({ communityInfo }: { communityInfo: TCommunityInfo }) => {
	return (
		<section
			className="flex w-full flex-col rounded-xl bg-blue-600 bg-cover bg-center bg-no-repeat max-md:max-w-full"
			style={{
				backgroundImage: `url(${ASSETS_BASE_PREFIX}/static-files/general-discussion-board/general-discussion-board-cover-image.png)`,
			}}
		>
			<div className="flex w-full flex-col items-center justify-center  px-20 py-8 max-md:max-w-full max-md:px-5">
				<h1 className="text-center text-3xl font-bold tracking-tighter text-white max-md:max-w-full md:text-4xl 2xl:text-5xl">
					Global proptech <br /> discussions that are buzzing!
				</h1>

				<div className="mx-auto mt-4 w-full max-w-3xl md:mt-8 3xl:max-w-4xl">
					<CommunitySearch />
				</div>

				<div className="mt-4 flex w-full flex-col items-center max-md:max-w-full md:mt-8">
					<p className="text-center text-lg font-medium leading-loose text-white max-md:max-w-full">
						Engage in this forum on any topic in global proptech.
					</p>

					<CommunityStats
						totalMembers={communityInfo.totalMembers}
						totalPosts={communityInfo.totalPosts}
						totalViews={communityInfo.totalViews}
					/>
				</div>
			</div>
		</section>
	);
};

export default PublicFeedHero;
